import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { useTreeContext } from './TreeView';

const TreeItem = ({
  nodeId,
  label,
  children,
  className,
  sx,
  collapseIcon,
  expandIcon,
  onClick,
  ...props
}) => {
  const { expanded, defaultCollapseIcon, defaultExpandIcon, onNodeToggle } = useTreeContext();

  const isExpanded = expanded.includes(nodeId);
  const hasChildren = React.Children.count(children) > 0;

  const handleToggle = (event) => {
    event.stopPropagation();
    if (hasChildren) {
      onNodeToggle(nodeId);
    }
  };

  const handleClick = (event) => {
    if (onClick) {
      onClick(event);
    }
    if (hasChildren) {
      handleToggle(event);
    }
  };

  // eslint-disable-next-line no-nested-ternary
  const displayIcon = hasChildren
    ? isExpanded
      ? collapseIcon || defaultCollapseIcon
      : expandIcon || defaultExpandIcon
    : null;

  return (
    <Box
      component='div'
      className={className}
      sx={{
        listStyle: 'none',
        ...sx,
      }}
      {...props}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          cursor: hasChildren ? 'pointer' : 'default',
          paddingY: 0.5,
          paddingLeft: 1,
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
          },
        }}
        onClick={handleClick}
      >
        {hasChildren && (
          <IconButton
            size='small'
            onClick={handleToggle}
            sx={{
              marginRight: 1,
              padding: 0.5,
              minWidth: 'auto',
            }}
            aria-label={isExpanded ? 'Collapse' : 'Expand'}
          >
            {displayIcon}
          </IconButton>
        )}
        {!hasChildren && <Box sx={{ width: 32, marginRight: 1 }} />}
        <Typography
          variant='body2'
          sx={{
            flexGrow: 1,
            userSelect: 'none',
          }}
        >
          {label}
        </Typography>
      </Box>
      {hasChildren && isExpanded && (
        <Box
          component='ul'
          role='group'
          sx={{
            listStyle: 'none',
            margin: 0,
            paddingLeft: 2,
          }}
        >
          {children}
        </Box>
      )}
    </Box>
  );
};

export default TreeItem;
